import React from 'react';
import { RolloverStatusFiltersProps } from '../types/RolloverStatusTypes';
import { FiltersContainer, FilterColumn, StyledTextField } from '../styled';
import DropdownSelect from '../../../components/DropdownSelect';

const RolloverStatusFilters: React.FC<RolloverStatusFiltersProps> = ({
  academicYear,
  setAcademicYear,
  grade,
  setGrade,
  gradeOptions,
  academicYearOptions,
  setHasSearched
}) => {
  const handleAcademicYearChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    const target = e.target as HTMLInputElement & { value: string };
    setAcademicYear(target.value);
    setHasSearched(false);
  };

  const handleGradeChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    const target = e.target as HTMLInputElement & { value: string };
    setGrade(target.value);
    setHasSearched(false);
  };

  return (
    <FiltersContainer>
      <FilterColumn>
        <StyledTextField>
          <DropdownSelect
            label='Academic Year'
            name='academicYear'
            value={academicYear}
            onChange={handleAcademicYearChange}
            options={academicYearOptions.map((a) => ({
              value: a.value,
              label: a.label
            }))}
            size='small'
            placeholder='Select Academic Year'
          />
        </StyledTextField>
      </FilterColumn>
      <FilterColumn>
        <StyledTextField>
          <DropdownSelect
            label='Grade'
            name='grade'
            value={grade}
            onChange={handleGradeChange}
            options={gradeOptions.map((g: any) => ({
              value: g.value,
              label: g.label
            }))}
            size='small'
            placeholder='Select Grade'
          />
        </StyledTextField>
      </FilterColumn>
    </FiltersContainer>
  );
};

export default RolloverStatusFilters;
